import { Settings } from "lucide-react";
import { ProjectConfigTab, ProjectConfigTabConfig } from "../ProjectConfigNav";

// Status tab configuration
export const STATUS_TAB_CONFIG: ProjectConfigTabConfig = {
  id: "statuses" as ProjectConfigTab,
  name: "Statuses",
  icon: Settings,
};

// Default status types for better organization
export const DEFAULT_STATUS_TYPES = [
  "backlog",
  "todo",
  "in-progress",
  "in-review",
  "done",
  "canceled",
  "blocked",
] as const;

// Status type display names
export const STATUS_TYPE_DISPLAY_NAMES: Record<string, string> = {
  backlog: "Backlog",
  todo: "Todo",
  "in-progress": "In Progress",
  "in-review": "In Review",
  blocked: "Blocked",
  done: "Done",
  canceled: "Canceled",
};

// Status validation rules
export const STATUS_VALIDATION_RULES = {
  minNameLength: 3,
  maxNameLength: 20,
  allowedTypes: DEFAULT_STATUS_TYPES,
} as const;

// Performance settings
export const PERFORMANCE_CONFIG = {
  debounceDelay: 300,
  highlightDuration: 1000,
  maxStatusItems: 100,
} as const;
